import React from "react";
import { useField } from "formik";
import Select from "react-select";
import { injectIntl } from "react-intl";
import FormikFormErrorHandler from "./FormikFormErrorHandler";

interface OptionType {
  value: string | number;
  label: string;
}

interface MultiSelectProps {
  name: string;
  options: OptionType[];
  isDisabled?: boolean;
  className?: string;
  intl: any; // IntlConfig
  placeholder?: string;
}

const FormikMultiSelect: React.FC<MultiSelectProps> = ({ name, options, isDisabled = false, className, intl, placeholder }) => {
  const [field, meta, helpers] = useField(name);
  const { setValue, setTouched } = helpers;

  return (
    <div>
      <Select
        isMulti
        name={name}
        options={options}
        isDisabled={isDisabled}
        className={meta.touched && meta.error ? "error-border" : className}
        value={options.filter(option => field.value.includes(option.value))}
        onChange={(selectedOptions) => {
          const selectedValues = selectedOptions.map(option => option.value);
          setValue(selectedValues);
        }}
        onBlur={(e) => {
          // prevent premature validation on first touch
          setTimeout(() => {
            setTouched(true);
          }, 100);
        }}
        placeholder={intl.formatMessage({ id: placeholder || "select_treatment" })}
        noOptionsMessage={() => intl.formatMessage({ id: "no_treatment_added" })}
      />

      <FormikFormErrorHandler intl={intl} meta={meta} />
    </div>
  );
};

export default injectIntl(FormikMultiSelect);
